import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { signUpSchema } from "../schemas/schemas";
import { useSignUpMutation } from '../api/mutations/signIn.mutation';
import { Logo } from "../assets/imageAssets";
import Input from "../components/Input";
import Button from "../components/Button";
import { GoogleLogin } from '@react-oauth/google';
import { Link } from "react-router-dom";

const Registration = () => {
    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        shouldFocusError: true,
        shouldUseNativeValidation: false,
        resolver: yupResolver(signUpSchema),
    });
    const { mutate } = useSignUpMutation();

    return (
        <div className="login">
            <div className="login__content flex flex-align-center flex-direction-col text-center">
                <div className="logo">
                    <img src={Logo} alt="Logo" />
                </div>
                <div>
                    <h1 className='mb-12'>Create an account</h1>
                    <p className='text-min text-color-grey'>Welcome! Please enter your details.</p>
                </div>
                <form className='full-width' onSubmit={handleSubmit(mutate)}>
                    <Input
                        label='Name'
                        placeholder='Enter your name'
                        id='first_name'
                        className={'mb-20'}
                        register={{ ...register('first_name') }}
                        error={errors?.first_name}
                        errorMessage={errors?.first_name?.message}
                    />
                    <Input
                        label='Email'
                        placeholder='Enter your email'
                        id='email'
                        className={'mb-20'}
                        register={{ ...register('email') }}
                        error={errors?.email}
                        errorMessage={errors?.email?.message}
                    />
                    <Input
                        label='Password'
                        placeholder='Enter you password'
                        id='password'
                        type='password'
                        className={'mb-20'}
                        register={{ ...register('password') }}
                        error={errors?.password}
                        errorMessage={errors?.password?.message}
                    />
                    <div className='mb-24 text-color-grey-dark'>
                        Already have an account?  <Link to={'/login'} className='text-underline'>Log In</Link>
                    </div>
                    <Button 
                        text='Sign up' 
                        className={'full-width mb-16'}
                    />
                    {/* <GoogleLogin
                        theme="outline"
                        text="signin_with"
                        shape="rectangular"
                        onSuccess={(credentialResponse) => {
                            // const decoded = jwt_decode(credentialResponse.credential);
                            console.log('User Info:', credentialResponse);
                        }}
                        onError={() => {
                            console.log('Login Failed');
                        }}
                    /> */}
                </form>
            </div>
        </div>
    );
}

export default Registration;